import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { SharedUiPersonaChoiceModule } from '@se-po/shared-ui-persona-choice'

import { PersonaPickerComponent } from './persona-picker/persona-picker.component'

@NgModule({
  imports: [
    CommonModule,
    SharedUiPersonaChoiceModule,
    SeFeTranslationsModule
  ],
  declarations: [PersonaPickerComponent],
  exports: [PersonaPickerComponent],
})
export class SharedUiPersonaPickerModule {}
